<template>
  <div>
    <audio-player/>
    <player-controls/>
    <router-view/>
  </div>
</template>

<script>
  import AudioPlayer from '@/components/AudioPlayer'
  import PlayerControls from '@/components/PlayerControls'

  export default {
    name: 'Player',
    components: {
      AudioPlayer,
      PlayerControls
    }
  }
</script>
